<template>
    <div>
        <span class="td prompt">
            <em class="instructions">Distribute the scores 1-4 over the statements below. Enter “4” for the statement that best describes you, and “1” for the statement that least describes you. <u>Each number (1-4) can only be used once</u>.</em><br>
            {{ prompt }}
        </span>
        <div class="tbl">
            <div :key="choice.text" v-for="choice in choices" class="tr">
                <input v-model="choice.value" type="text" :name="'question[' + question.id + '][' + choice.cat + ']'" class="td" maxlength="1" />
                <span class="td">{{ choice.text }}</span>
            </div>
        </div>
        <div v-show="showValidation && validationMessage" class="alert is-error">{{ validationMessage }}</div>
    </div>
</template>

<script>
export default {
    name: 'SurveyQuestionRatedMultiple',
    props: {
        question: Object,
        showValidation: Boolean
    },
    computed: {
        prompt: function () {
            return this.question.question
        },
        choices: function () {
            return this.question.choices
        },
        validationMessage: function () {
            if (this.isValid) {
                return '';
            }
            return this.badInput ? 'Enter scores (1-4) above, one for each statement.' : 'You can only use each number (1-4) one time.'
        },
        badInput: function () {
            for (var c of this.choices) {
                switch (c.value) {
                    case '1':
                    case '2':
                    case '3':
                    case '4':
                        break;
                    default:
                        return true;
                }
            }
            return false;
        },
        isValid: function () {
            var one, two, three, four;
            for (var c of this.choices) {
                switch (c.value) {
                    case '1':
                        one = true;
                        break;
                    case '2':
                        two = true;
                        break;
                    case '3':
                        three = true;
                        break;
                    case '4':
                        four = true;
                        break;
                    default:

                }
            }

            return one && two && three && four;
        }
    }
}
</script>

<style lang="scss">
.tbl{
    display: table;
}
.tr {
    display: table-row;
}
.td {
    display: table-cell;
}
.question {
    input {
        width: 3em;
        margin: .5em .5em 0 0;
    }
    .td {
        text-align: left;
    }
}
</style>
